module.exports = __webpack_public_path__ + "static/media/building-02.63e89cb1.png";